const SupportMainView = () => import('@/views/superadmin/support/SupportMainView')
const SupportContactsView = () => import('@/views/superadmin/support/SupportContactsView')
const SupportRequestsView = () => import('@/views/superadmin/support/SupportRequestsView')

export default {
  path: 'support',
  redirect: { name: 'SupportRequestsSuperAdmin' },
  name: 'SupportMainSuperAdmin',
  component: SupportMainView,
  meta: { label: 'Тех Поддержка' },
  children: [
    {
      path: 'requests',
      name: 'SupportRequestsSuperAdmin',
      component: SupportRequestsView,
      meta: { label: 'Сообщения' },
    },
    {
      path: 'contacts',
      name: 'SupportContactsViewSuperAdmin',
      component: SupportContactsView,
      meta: { label: 'Контакты' },
    },
  ]
}